var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_vm._m(0),_c('div',{staticClass:"main-container"},[_c('router-view')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":require("../assets/images/bg.png"),"alt":""}})])
}]

export { render, staticRenderFns }